import { Children, type ReactNode } from 'react';
import {
  Box,
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuList,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';
import { ListFilter } from 'lucide-react';
import { t } from '@lingui/core/macro';
import { iconSize } from '@duke-hq/ui/constants/scalable';

// Inline filter chips on wider screens. Below `lg` they would overflow the row,
// so they collapse into a single "Filters" dropdown (each filter rendered as a
// full-width row inside the menu).
export function FilterBar({ children }: { children: ReactNode }): React.JSX.Element {
  const isSmallScreen = useBreakpointValue({ base: true, lg: false }) ?? false;

  if (!isSmallScreen) {
    return (
      <HStack gap={2} alignItems="center">
        {children}
      </HStack>
    );
  }

  return (
    <Menu closeOnSelect={false}>
      <MenuButton as={Button} variant="outline" px={3} leftIcon={<ListFilter size={iconSize.md} />}>
        <Text textStyle="sm" fontWeight="semibold" color="fg.emphasis">
          {t`Filters`}
        </Text>
      </MenuButton>
      <MenuList p={0} overflow="hidden">
        {Children.map(children, (child) => (
          <Box sx={{ button: { width: '100%', textAlign: 'left', borderRadius: '0' } }}>
            {child}
          </Box>
        ))}
      </MenuList>
    </Menu>
  );
}
